import { useTranslations } from "@zapier/i18n";
import { useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useChatbotsLimits } from "@zapier/client";
import { Alert } from "@zapier/design-system";
import { logWithNotification } from "@zapier/shared";
import styles from "./ChatbotsUpsell.module.css";

function ChatbotsUpsellInner() {
  const t = useTranslations("chatbots-upsell");

  const { chatbotCount, chatbotLimit } = useChatbotsLimits();

  const shouldShowWarning = useMemo(() => {
    if (!chatbotCount || !chatbotLimit) {
      return false;
    }

    return chatbotCount >= chatbotLimit;
  }, [chatbotCount, chatbotLimit]);

  if (!shouldShowWarning) {
    return;
  }

  return (
    <div className={styles.root}>
      <Alert
        title={
          <>
            {t("usage-warning.title", {
              chatbotCount: new Intl.NumberFormat().format(chatbotCount || 0),
              chatbotLimit: new Intl.NumberFormat().format(chatbotLimit || 0),
            })}
          </>
        }
      />
    </div>
  );
}

export function ChatbotsUpsell() {
  return (
    <ErrorBoundary
      fallbackRender={() => <></>}
      onError={(error, info) => {
        const message = error instanceof Error ? error.message : String(error);
        logWithNotification(
          `Error in ChatbotsUpsell: ${message}. Info: ${info.componentStack}`,
          "error",
        );
      }}
    >
      <ChatbotsUpsellInner />
    </ErrorBoundary>
  );
}
